import React from "react";
import styles from "./FollowUpSuggestions.module.css";

interface FollowUpSuggestionsProps {
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
  disabled?: boolean;
}

export const FollowUpSuggestions: React.FC<FollowUpSuggestionsProps> = ({
  suggestions,
  onSuggestionClick,
  disabled = false,
}) => {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.label}>Explore further:</div>
      <div className={styles.suggestionsGrid}>
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            className={styles.suggestionButton}
            onClick={() => onSuggestionClick(suggestion)}
            disabled={disabled}
            type="button"
          >
            <span className={styles.suggestionText}>{suggestion}</span>
            <svg
              className={styles.arrowIcon}
              width="14"
              height="14"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 8h9m0 0L9 4.5m3.5 3.5L9 11.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        ))}
      </div>
    </div>
  );
};
